export enum HistoryType {
	PREQUALIFIED = 'PREQUALIFIED',
	CONTACTED = 'CONTACTED',
	INTERVIEW = 'INTERVIEW',
	COMPANY_PROPOSED = 'COMPANY_PROPOSED',
	COMPANY_INTERVIEW = 'COMPANY_INTERVIEW',
	MISSION_PROPOSED = 'MISSION_PROPOSED',
	REJECTED = 'REJECTED',
}

export interface HistoryEntry {
	type: HistoryType;
	date: Date;
}
